import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ImplementService } from 'src/app/services/implement.service';

@Component({
  selector: 'app-implement-select-dialog',
  templateUrl: './implement-select-dialog.component.html',
  styleUrls: ['./implement-select-dialog.component.scss'],
})
export class ImplementSelectDialogComponent implements OnInit {
  implementList = null;
  selectedImplement = null;
  selectedImplementId = null;

  constructor(
    private implementService: ImplementService,
    public modalCtrl: ModalController
  ) {
    this.implementService.onGetImplements().subscribe((implements_) => {
      this.implementList = [...implements_];
    });
  }

  ngOnInit() {
    console.log(this.implementList);
  }

  dismiss() {
    this.modalCtrl.dismiss({
      selectedImplement: this.selectedImplement,
      selectedImplementId: this.selectedImplementId,
    });
  }

  onSelectImplement(implementId) {
    this.selectedImplement = this.implementService.getImplementById(implementId);
    this.selectedImplementId = this.selectedImplement.id;
    this.dismiss();
  }
}
